<h2>Line</h2>
<assessment-row title="Description">
  <p>{{ data.lineDescription }}</p>
</assessment-row>

<assessment-row title="Intake">
  <p>{{ data.lineIntake }}</p>
</assessment-row>

<assessment-row title="Output">
  <p>{{ data.lineOutput }}</p>
</assessment-row>

<h2>Tube</h2>
<assessment-row title="Description">
  <p>{{ data.tubeDescription }}</p>
</assessment-row>

<assessment-row title="Intake">
  <p>{{ data.tubeIntake }}</p>
</assessment-row>

<assessment-row title="Output">
  <p>{{ data.tubeOutput }}</p>
</assessment-row>

<h2>Drain</h2>
<assessment-row title="Description">
  <p>{{ data.drainDescription }}</p>
</assessment-row>

<assessment-row title="Intake">
  <p>{{ data.drainIntake }}</p>
</assessment-row>

<assessment-row title="Output">
  <p>{{ data.drainOutput }}</p>
</assessment-row>

<h2>Airway</h2>
<assessment-row title="Description">
  <p>{{ data.airwayDescription }}</p>
</assessment-row>

<assessment-row title="Intake">
  <p>{{ data.airwayIntake }}</p>
</assessment-row>

<assessment-row title="Output">
  <p>{{ data.airwayOutput }}</p>
</assessment-row>
